import {formatLocaleDate} from '@/dayjs'
import {TKey} from '@/translations/i18n'
import {WorkSector, DateRangeFilterEnum} from '@/types'
import {capitalize} from '@/utilities/helpers'
import {ProjectExtended} from '../projects/types'

export const chartTickFormatter = (type: 'day' | 'month', value: string) => {
    if (type === 'day') {
        return capitalize(formatLocaleDate(value, 'D MMMM'))
    }
    return capitalize(formatLocaleDate(value, 'MMMM'))
}

export const dashboardFiltersWorkSectorToLabel = {
    outpatient: 'commons:outpatient',
    domiciliary: 'commons:domiciliary',
    all: 'commons:view_all'
} as const satisfies Record<Exclude<WorkSector, 'outpatient_domiciliary'>, TKey> & {all: TKey}

export const dashboardFiltersAssistiveRegimeToLabel = {
    autism: 'projects:care_sub_regime_autism_intellectual_disabilities',
    adults: 'projects:care_sub_regime_adults_other_diagnoses',
    minors: 'projects:care_sub_regime_minors_other_diagnoses',
    all: 'commons:view_all'
} as const satisfies Record<NonNullable<ProjectExtended['assistiveRegime']>, TKey> & {all: TKey}

export const periodToDistributionLabel = {
    month: 'dashboard:month_distribution',
    threeMonths: 'dashboard:three_months_distribution',
    sixMonths: 'dashboard:six_months_distribution',
    year: 'dashboard:year_distribution'
} as const satisfies Record<DateRangeFilterEnum, TKey>

/**
 * Calculates the first margin from billing and costs data
 * @param billedAccesses - Revenue from billed accesses (default: 0)
 * @param costs - Total calculated costs (default: 0)
 * @returns First margin (revenue - costs)
 */
export const calculateFirstMargin = (billedAccesses: number = 0, costs: number = 0): number => {
    return billedAccesses - costs
}

/**
 * Calculates the operating margin from first margin and other costs
 * @param firstMargin - First margin value (default: 0)
 * @param otherCosts - Other additional costs (default: 0)
 * @returns Operating margin (first margin - other costs)
 */
export const calculateOperatingMargin = (firstMargin: number = 0, otherCosts: number = 0): number => {
    return firstMargin - otherCosts
}
